define("Widgets/ScrollContent", [`Controller`, `module`], (Super, Self) => {
	return Super.inherit({
		namespace: Self.id,
		defaults: {
			loadStylesheet: true,
			interceptEvents: false,
		},
		constructor(setup) {
			// variables used to track the total width and current position
			this.data.top = 0;
			this.data.left = 0;
			this.data.animating = false;
			this.data.scrollable = false;

			this.elements.list = this.get(`ul`);
			this.elements.items = this.isArray(setup.elements, 1) ? setup.elements : [];

			// this.elements.list.style.left = '0';
			this.elements.list.style.transform = `none`;

			this.redraw();

			this.each([100, 500, 3000], function (duration) {
				this.defer({
					// recalculate dimensions after 'duration' milliseconds
					duration,
					then: this.redraw,
					done: true,
				});
			});
		},
		api: {
			redraw: {
				value() {
					const { DOM, callbacks, data, dimensions, elements } = this;
					const { items, list: listElement } = elements;
					const listDimensions = DOM.getDimensions(listElement);
					const { paddingBottom, paddingLeft, paddingRight, paddingTop } = listDimensions;
					// used to hold the dimensions of any detected padding
					const buffers = { top: paddingTop, right: paddingRight, bottom: paddingBottom, left: paddingLeft };
					let scrollableX;
					let scrollableY;
					let column;
					let evt;

					data.buffers = buffers;

					while (listElement.children.length > 0) {
						listElement.removeChild(listElement.children[0]);
					}

					this.each(items, (element) => {
						// iterate over each element
						column = document.createElement(`li`);
						listElement.appendChild(column);

						column.appendChild(element);
					});

					if (listDimensions.scrollWidth <= dimensions.width) {
						data.maxScrollX = 0;
						scrollableX = false;
					} else {
						// scrolling to be done
						data.maxScrollX = listElement.scrollWidth - dimensions.width + buffers.right;
						scrollableX = true;
					}

					if (listDimensions.scrollHeight <= dimensions.height) {
						data.maxScrollY = 0;
						scrollableY = false;
					} else {
						// scrolling to be done
						data.maxScrollY = listElement.scrollHeight - dimensions.height + buffers.bottom;
						scrollableY = true;
					}

					if (this.isFunction(callbacks.redraw)) {
						evt = this.defineProperties(
							{},
							{
								scrollableX: {
									value: scrollableX,
								},
								scrollableY: {
									value: scrollableY,
								},
							}
						);

						callbacks.redraw(evt);
					}
				},
			},

			scrollTo: {
				public: true,
				defaults: {
					target: null, // scroll a specific element into view
					duration: 500,
				},
				value(context, options) {
					const { DOM, data, elements } = this;

					this.redraw();

					var KEYWORDS = DOM.getVendorKeywords();
					const viewportDimensions = DOM.getDimensions();
					const buffers = data.buffers;
					const listElement = elements.list;
					const listDimensions = DOM.getDimensions(listElement);
					const listLeft = -1 * listDimensions.left;
					const listRight = listLeft + viewportDimensions.width;
					const maxScrollX = data.maxScrollX;
					let elementRight;
					let elementLeft;
					let dimensions;
					let left;
					let evt;

					if (this.isElement(options.target)) {
						if (data.animating) {
							return;
						}

						dimensions = DOM.getDimensions(options.target);
						elementLeft = listLeft + dimensions.left;
						elementRight = elementLeft + dimensions.width; // distance between left edge and element right edge

						if (elementLeft < listLeft) {
							// too far left, shift right
							left = elementLeft - viewportDimensions.width + dimensions.width + buffers.right;
						} else if (elementRight > listRight) {
							// too far right, shift left
							left = elementLeft - buffers.left;
						}

						if (this.isFinite(left)) {
							// an updated scroll calculation was made
							data.animating = true;
							listElement.style[KEYWORDS.transition + `Duration`] = options.duration + `ms`;

							if (this.isFunction(this.callbacks.scroll)) {
								evt = this.defineProperties(
									{},
									{
										scrolledX: {
											get: function () {
												var result = maxScrollX > 0 ? left / maxScrollX : 0;
												return result;
											},
										},
										// TODO: implement
										// scrolledY: {
										// 	get: function( ) { }
										// }
									}
								);

								this.callbacks.scroll(evt);
							}

							this.defer({
								duration: options.duration + 10,
								then: function () {
									this.data.animating = false;
									listElement.style[KEYWORDS.transition + `Duration`] = `0`;
								},
							});

							if (left > maxScrollX) {
								left = maxScrollX;
							} else if (left < 0) {
								left = 0;
							}

							listElement.style.transform = `translateX(` + -1 * left + `px)`;

							// TODO: handling top vertical scrolling adjusting the 'top' property
						}
					} else if (this.isString(options.direction)) {
						this.find(this.elements.items, function (item, i, items) {
							dimensions = DOM.getDimensions(item);

							if (options.direction === `left`) {
								// looking for the right-most hidden element to the left
								if (dimensions.viewportLeft > viewportDimensions.viewportLeft) {
									// element is left of the viewport
									this.scrollTo({
										target: i > 0 ? items[i - 1] : item,
									});
									return true; // break loop
								}
							} else if (options.direction === `right`) {
								if (viewportDimensions.viewportRight > dimensions.viewportRight) {
									// element is right of the viewport
									this.scrollTo({
										target: item,
									});
									return true; // break loop
								}
							}
						});
					}
				},
			},
		},
		listeners: [
			{
				event: `resize`,
				target: window,
				throttle: 200, // don't fire too often
				handler() {
					this.redraw();
				},
			},
		],
	});
});

//# sourceMappingURL=ScrollContent.js.map